import { WaitingRoomInterface } from './initialState.interface';

export const waitingRoomInitialState: WaitingRoomInterface = {
  loading: false,
  posts: null,
  alert: false,
};
